export default "__VITE_ASSET__d6fb2495__"